import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { TChatState, TGroup } from "@/types/public";

const initialState: TChatState = {
  groupList: [],
  openedGroup: null,
};

const slice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setOpenedGroup: (state, action: PayloadAction<TGroup>) => {
      state.openedGroup = action.payload;
    },
    clearOpenedGroup: (state) => {
      state.openedGroup = null;
    },
    setGroupList: (state, action: PayloadAction<TGroup[]>) => {
      state.groupList = action.payload;
    },
  },
});

export const { setOpenedGroup, setGroupList, clearOpenedGroup } = slice.actions;

export default slice.reducer;

export const selectCurrentChat = (state: RootState) => state.chat;
